import { useState } from 'react';
import './App.css';
import Minesweeper from './Minesweeper/Minesweeper';

function App() {

    let [fields, setFields] = useState({})

    let [isSubmit, setIsSubmit] = useState(false)

    const handleSubmit = (diff) => {

        console.log(diff)

        switch(diff){
            case 'easy':
                setFields({size: 10, num: 8})
                break
            case 'medium':
                setFields({size: 15, num: 20})
                break
            case 'hard':
                setFields({size: 20, num: 25})
                break
        }

        setIsSubmit(true)

    }

    return (
        <div className="App">
            {!isSubmit ? 
            <div className='input'>
                <p>Select Difficulty</p>
                <button onClick={()=>{handleSubmit('easy')}}>Easy</button>
                <button onClick={()=>{handleSubmit('medium')}}>Medium</button>
                <button onClick={()=>{handleSubmit('hard')}}>Hard</button>
            </div>
            : 
            <Minesweeper size={fields.size} num={fields.num} setIsSubmit={setIsSubmit} />}
        </div>
    );
}

export default App;
